import { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useProviderOrderCode from '@hooks/useProviderOrderCode'

const confirmDelete = (deleteProviderOrderCode, deleteFn) => {
  const deleteProviderOrderCodePayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Order Code Deleted',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, delete it.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Delete Order Code?',
  }).then(({ value }) => {
    if (value){
      deleteProviderOrderCode(deleteProviderOrderCodePayload)
    }
  })
}

const OrderCodeListItem = (props) => {
  const { providerOrderCode } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks,
  } = pageContext
  const { deleteProviderOrderCode } = callbacks || {}

  const {
    callbacks: { createOrEditProviderOrderCode, deleteProviderOrderCode: deleteFn },
    providerOrderCode: {
      options_string,
      provider_code,
      quantity,
    },
    providerPriceList: { title: providerPriceListTitle },
    serviceProduct: { title: serviceProductTitle },
  } = useProviderOrderCode(providerOrderCode)

  return (
    <DashboardModuleListItem
      secondaryText={`${quantity} x ${serviceProductTitle}${options_string}`}
      title={provider_code}
    >
      <DashboardModuleListItem.TertiaryText>
        {providerPriceListTitle}
      </DashboardModuleListItem.TertiaryText>

      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => createOrEditProviderOrderCode()}
          type="edit"
        />

        <DashboardModuleListItem.Icon onClick={() => confirmDelete(deleteProviderOrderCode, deleteFn)} type="delete" />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

OrderCodeListItem.propTypes = {
  providerOrderCode: PropTypes.object.isRequired,
}

export default OrderCodeListItem
